import React from 'react';

import PropTypes from 'prop-types';

import { AddressInput } from './address-input';
import { AutoCompleteField } from '../../../constants/autocomplete-field';
import { FIELD_NAMES } from '../constants';

export const PostalCodeField = ({ optional = false }) => {
  return <AddressInput autoComplete={AutoCompleteField.PostalCode} field={FIELD_NAMES.POSTAL_CODE} optional={optional} />;
};

PostalCodeField.propTypes = {
  optional: PropTypes.bool,
};
